var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{class:(_vm.options.fix?'fix':'') + ' intelligentLoadingContainer'},[_c('div',{staticClass:"intelligentLoadingIcon"},[_c('div',{staticClass:"intelligentLoading"}),_c('span',{staticClass:"intelligentLoadingTip"},[_vm._v(_vm._s(_vm.options.tips))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }